import React from 'react'
import { Button, Icon } from '@mobi/component-library/Common/V2'
import { FollowButtonLocation } from '../types'

export const UnfollowButtonComponent: React.FC<{
  isPending: boolean
  handleFollowClick: () => void
  location: FollowButtonLocation
}> = ({ isPending, handleFollowClick, location }) => {
  return (
    <Button
      data-testid='bet-loop-unfollow-btn'
      size='sm'
      color='secondary_outline'
      disabled={isPending}
      onClick={handleFollowClick}
    >
      {location === 'follow-list' ? (
        <span>Unfollow</span>
      ) : (
        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          Following <Icon name='LineCheck' size='1.5rem' />
        </span>
      )}
    </Button>
  )
}
